export function getNextContentId(items, idKey) {
  const highestId = (items || []).reduce((highest, item) => {
    const id = Number(item?.[idKey]);
    return Number.isInteger(id) && id > highest ? id : highest;
  }, 0);

  return highestId + 1;
}
